import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import HttpService from "../../hooks/Https-services";
import PageRoutes, { APIRoutes } from "../../utils/constants";

interface ChannelShareActionProps {
  action: "accept" | "decline";
}

const ChannelShareAction = ({ action }: ChannelShareActionProps) => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const [channelId, setChannelId] = useState<number | null>(null);

  useEffect(() => {
    if (!token) return;

    const doAction = async () => {
      try {
        const route =
          action === "accept"
            ? APIRoutes.AcceptChannelShare.replace(":token", token)
            : APIRoutes.DeclineChannelShare.replace(":token", token);

        const res = await HttpService.post(route, {});
        setStatus("success");
        setMessage(
          action === "accept"
            ? "Channel accepted! It has been added to your Personal Channels."
            : "You have declined the share request."
        );
        if (action === "accept" && res?.data?.data?.channelId) {
          setChannelId(res.data.data.channelId);
        }
      } catch (err: any) {
        setStatus("error");
        setMessage(err?.response?.data?.message || "Something went wrong. The link may have expired or already been used.");
      }
    };

    doAction();
  }, [token, action]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      gap={2}
      px={2}
      textAlign="center"
    >
      {status === "loading" && (
        <>
          <CircularProgress />
          <Typography>Processing your request...</Typography>
        </>
      )}
      {status === "success" && (
        <>
          <Typography variant="h5" fontWeight={600}>
            {action === "accept" ? "Channel Accepted!" : "Request Declined"}
          </Typography>
          <Typography color="text.secondary">{message}</Typography>
          {channelId ? (
            <Button
              variant="contained"
              onClick={() =>
                navigate(PageRoutes.PersonalChannel.replace(":id", String(channelId)))
              }
            >
              Go to Channel
            </Button>
          ) : (
            <Button variant="outlined" onClick={() => navigate(PageRoutes.HomePage)}>
              Go to Home
            </Button>
          )}
        </>
      )}
      {status === "error" && (
        <>
          <Typography variant="h5" fontWeight={600} color="error">
            Unable to Process Request
          </Typography>
          <Typography color="text.secondary">{message}</Typography>
          <Button variant="outlined" onClick={() => navigate(PageRoutes.HomePage)}>
            Go to Home
          </Button>
        </>
      )}
    </Box>
  );
};

export default ChannelShareAction;
